import * as types from "./types";

export const setUserAuth = (data, authenticate, moduleAccessList, accessList,) => ({
    type: types.SET_USER_AUTH,
    payload: data,
    isAuthenticated: authenticate,
    getmoduleAccessList: moduleAccessList,
    getaccessList: accessList,
});

export const updateField = (data) => ({
    type: types.CHG_FIELD,
    payload: data,
})

export const refreshForm = () => ({
    type: types.REFRESH_FORM
})

export const isLoading = (showLoader) => ({
    type: types.SET_LOADER,
    payload: showLoader
})

export const setAuthenticated = (isAuthenticated) => ({
    type: types.SET_AUTHENTICATED,
    payload: isAuthenticated
})

export const updateCredentials = (data) => ({
    type: types.UPDATE_CREDENTIALS,
    payload: data
})

export const setPulbicAuthenticated = (isPublicAuthenticated) => ({
    type: types.SET_PUBLIC_AUTHENTICATED,
    payload: isPublicAuthenticated
})

